import { consumptions } from '@markku/db'
import { createInsertSchema, createSelectSchema } from 'drizzle-zod'
import { z } from 'zod'

// Auto-generate base schemas
export const selectConsumptionSchema = createSelectSchema(consumptions)
export const insertConsumptionSchema = createInsertSchema(consumptions).omit({
  id: true,
  createdAt: true,
  updatedAt: true,
  deletedAt: true,
})

// Export minimal type aliases
export type Consumption = z.infer<typeof selectConsumptionSchema>
export type InsertConsumption = z.infer<typeof insertConsumptionSchema>
